export default __webpack_public_path__ + "static/media/Geon of Four Trigrams.98803352.png";